import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const PostRedirect = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            navigate("/post", { replace: true, state: { postId: id } });
        }
    }, [id, navigate]);

    return null;
};

export default PostRedirect;
